module.exports = __webpack_public_path__ + "static/media/zero-banner-zh.d691c2fa.png";